// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Plan from "./plan.js"
import StripeProduct from "./stripe-product.js"

const modelClassData = {
  "attributes": {
    "amount": {
      "column": null,
      "name": "amount",
      "selected_by_default": null,
      "translated": null
    },
    "created": {
      "column": {
        "default": null,
        "name": "created",
        "null": true,
        "type": "datetime"
      },
      "name": "created",
      "selected_by_default": null,
      "translated": null
    },
    "deleted_at": {
      "column": {
        "default": null,
        "name": "deleted_at",
        "null": true,
        "type": "datetime"
      },
      "name": "deleted_at",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "name": {
      "column": null,
      "name": "name",
      "selected_by_default": null,
      "translated": null
    },
    "nickname": {
      "column": {
        "default": null,
        "name": "nickname",
        "null": true,
        "type": "string"
      },
      "name": "nickname",
      "selected_by_default": null,
      "translated": null
    },
    "currency": {
      "column": {
        "default": null,
        "name": "currency",
        "null": false,
        "type": "string"
      },
      "name": "currency",
      "selected_by_default": null,
      "translated": null
    },
    "interval": {
      "column": {
        "default": null,
        "name": "interval",
        "null": false,
        "type": "string"
      },
      "name": "interval",
      "selected_by_default": null,
      "translated": null
    },
    "interval_count": {
      "column": {
        "default": null,
        "name": "interval_count",
        "null": false,
        "type": "integer"
      },
      "name": "interval_count",
      "selected_by_default": null,
      "translated": null
    },
    "statement_descriptor": {
      "column": {
        "default": null,
        "name": "statement_descriptor",
        "null": true,
        "type": "string"
      },
      "name": "statement_descriptor",
      "selected_by_default": null,
      "translated": null
    },
    "stripe_id": {
      "column": {
        "default": null,
        "name": "stripe_id",
        "null": false,
        "type": "string"
      },
      "name": "stripe_id",
      "selected_by_default": null,
      "translated": null
    },
    "trial_period_days": {
      "column": {
        "default": null,
        "name": "trial_period_days",
        "null": true,
        "type": "integer"
      },
      "name": "trial_period_days",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    },
    "translated_description": {
      "column": null,
      "name": "translated_description",
      "selected_by_default": false,
      "translated": null
    },
    "translated_name": {
      "column": null,
      "name": "translated_name",
      "selected_by_default": false,
      "translated": null
    }
  },
  "className": "StripePlan",
  "collectionKey": "stripe_plans",
  "collectionName": "stripe_plans",
  "i18nKey": "stripe_plan",
  "camelizedLower": "stripePlan",
  "name": "StripePlan",
  "nameDasherized": "stripe-plan",
  "pluralName": "stripe_plans",
  "ransackable_associations": [
    {
      "className": "ActiveRecordAuditable::Audit",
      "collectionName": "audits",
      "foreignKey": "auditable_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "Audit",
      "through": null
    },
    {
      "className": "ActiveRecordAuditable::Audit",
      "collectionName": "audits",
      "foreignKey": "auditable_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "Audit",
      "through": null
    },
    {
      "className": "Plan",
      "collectionName": "plans",
      "foreignKey": "plan_id",
      "name": "plan",
      "macro": "has_one",
      "resource_name": "Plan",
      "through": "plan_resource"
    },
    {
      "className": "PlanResource",
      "collectionName": "plan_resources",
      "foreignKey": "plan_resource_id",
      "name": "plan_resource",
      "macro": "has_one",
      "resource_name": "PlanResource",
      "through": "plan_resource_period"
    },
    {
      "className": "PlanResourcePeriod",
      "collectionName": "plan_resource_periods",
      "foreignKey": "stripe_plan_id",
      "name": "plan_resource_period",
      "macro": "has_one",
      "resource_name": "PlanResourcePeriod",
      "through": null
    },
    {
      "className": "StripeInvoiceItem",
      "collectionName": "stripe_invoice_items",
      "foreignKey": "stripe_plan_id",
      "name": "stripe_invoice_items",
      "macro": "has_many",
      "resource_name": "StripeInvoiceItem",
      "through": null
    },
    {
      "className": "StripeProduct",
      "collectionName": "stripe_products",
      "foreignKey": "stripe_product_id",
      "name": "stripe_product",
      "macro": "belongs_to",
      "resource_name": "StripeProduct",
      "through": null
    },
    {
      "className": "StripeSubscriptionItem",
      "collectionName": "stripe_subscription_items",
      "foreignKey": "stripe_plan_id",
      "name": "stripe_subscription_items",
      "macro": "has_many",
      "resource_name": "StripeSubscriptionItem",
      "through": null
    },
    {
      "className": "StripeSubscriptionSchedulePhasePlan",
      "collectionName": null,
      "foreignKey": "stripe_plan_id",
      "name": "stripe_subscription_schedule_phase_plans",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    },
    {
      "className": "StripeSubscription",
      "collectionName": "stripe_subscriptions",
      "foreignKey": "stripe_plan_id",
      "name": "stripe_subscriptions",
      "macro": "has_many",
      "resource_name": "StripeSubscription",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "active",
      "column": {
        "default": null,
        "name": "active",
        "null": true,
        "type": "boolean"
      }
    },
    {
      "name": "aggregate_usage",
      "column": {
        "default": null,
        "name": "aggregate_usage",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "amount_cents",
      "column": {
        "default": null,
        "name": "amount_cents",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "amount_currency",
      "column": {
        "default": null,
        "name": "amount_currency",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "amount_decimal",
      "column": {
        "default": null,
        "name": "amount_decimal",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "billing_scheme",
      "column": {
        "default": null,
        "name": "billing_scheme",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "created",
      "column": {
        "default": null,
        "name": "created",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "currency",
      "column": {
        "default": null,
        "name": "currency",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "deleted_at",
      "column": {
        "default": null,
        "name": "deleted_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "interval",
      "column": {
        "default": null,
        "name": "interval",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "interval_count",
      "column": {
        "default": null,
        "name": "interval_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "livemode",
      "column": {
        "default": "1",
        "name": "livemode",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "metadata",
      "column": {
        "default": null,
        "name": "metadata",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "nickname",
      "column": {
        "default": null,
        "name": "nickname",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "statement_descriptor",
      "column": {
        "default": null,
        "name": "statement_descriptor",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "stripe_id",
      "column": {
        "default": null,
        "name": "stripe_id",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "stripe_product_id",
      "column": {
        "default": null,
        "name": "stripe_product_id",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "trial_period_days",
      "column": {
        "default": null,
        "name": "trial_period_days",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "usage_type",
      "column": {
        "default": null,
        "name": "usage_type",
        "null": true,
        "type": "string"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [
    {
      "className": "Plan",
      "collectionName": "plans",
      "foreignKey": "plan_id",
      "name": "plan",
      "macro": "has_one",
      "resource_name": "Plan",
      "through": "plan_resource"
    },
    {
      "className": "StripeProduct",
      "collectionName": "stripe_products",
      "foreignKey": "stripe_product_id",
      "name": "stripe_product",
      "macro": "belongs_to",
      "resource_name": "StripeProduct",
      "through": null
    }
  ],
  "paramKey": "stripe_plan",
  "primaryKey": "id"
}

/** Frontend model for StripePlan. */
export default class StripePlan extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {any} */
  amount() {
    return this.readAttributeUnderscore("amount")
  }

  /** @returns {boolean} */
  hasAmount() {
    const value = this.amount()

    return this._isPresent(value)
  }

  /** @returns {Date | null} */
  created() {
    return this.readAttributeUnderscore("created")
  }

  /** @returns {boolean} */
  hasCreated() {
    const value = this.created()

    return this._isPresent(value)
  }

  /** @returns {Date | null} */
  deletedAt() {
    return this.readAttributeUnderscore("deleted_at")
  }

  /** @returns {boolean} */
  hasDeletedAt() {
    const value = this.deletedAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {any} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  nickname() {
    return this.readAttributeUnderscore("nickname")
  }

  /** @returns {boolean} */
  hasNickname() {
    const value = this.nickname()

    return this._isPresent(value)
  }

  /** @returns {string} */
  currency() {
    return this.readAttributeUnderscore("currency")
  }

  /** @returns {boolean} */
  hasCurrency() {
    const value = this.currency()

    return this._isPresent(value)
  }

  /** @returns {string} */
  interval() {
    return this.readAttributeUnderscore("interval")
  }

  /** @returns {boolean} */
  hasInterval() {
    const value = this.interval()

    return this._isPresent(value)
  }

  /** @returns {number} */
  intervalCount() {
    return this.readAttributeUnderscore("interval_count")
  }

  /** @returns {boolean} */
  hasIntervalCount() {
    const value = this.intervalCount()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  statementDescriptor() {
    return this.readAttributeUnderscore("statement_descriptor")
  }

  /** @returns {boolean} */
  hasStatementDescriptor() {
    const value = this.statementDescriptor()

    return this._isPresent(value)
  }

  /** @returns {string} */
  stripeId() {
    return this.readAttributeUnderscore("stripe_id")
  }

  /** @returns {boolean} */
  hasStripeId() {
    const value = this.stripeId()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  trialPeriodDays() {
    return this.readAttributeUnderscore("trial_period_days")
  }

  /** @returns {boolean} */
  hasTrialPeriodDays() {
    const value = this.trialPeriodDays()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedDescription() {
    return this.readAttributeUnderscore("translated_description")
  }

  /** @returns {boolean} */
  hasTranslatedDescription() {
    const value = this.translatedDescription()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedName() {
    return this.readAttributeUnderscore("translated_name")
  }

  /** @returns {boolean} */
  hasTranslatedName() {
    const value = this.translatedName()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  destroyOnStripe(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "destroy_on_stripe",
        primaryKey: this.primaryKey(),
        collectionName: "stripe_plans",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  updateOnStripe(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "update_on_stripe",
        primaryKey: this.primaryKey(),
        collectionName: "stripe_plans",
        type: "member"
      },
      commandArgs
    ))
  }

  /** @returns {import("./plan.js").default | null} */
  plan() {
    return this._readHasOneReflection({modelClass: Plan, reflectionName: "plan"})
  }

  /** @returns {Promise<import("./plan.js").default | null>} */
  loadPlan() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()

    return this._loadHasOneReflection(
      {
        reflectionName: "plan",
        model: this,
        modelClass: Plan
      },
      {
        params: {
          through: {
            model: "StripePlan",
            id,
            reflection: "plan"
          }
        }
      }
    )
  }

  /** @returns {Promise<import("./plan.js").default | null>} */
  ensurePlanLoaded() {
    return this.ensureAssociationLoaded("plan")
  }

  /** @returns {import("./stripe-product.js").default | null} */
  stripeProduct() {
    return this._readBelongsToReflection({modelClass: StripeProduct, reflectionName: "stripe_product"})
  }

  /** @returns {Promise<import("./stripe-product.js").default | null>} */
  loadStripeProduct() {
    if (!("stripeProductId" in this)) throw new Error("Foreign key method wasn't defined: stripeProductId")

    const id = this.stripeProductId()
    const ransack = {}

    ransack["stripe_id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "stripe_product",
        model: this,
        modelClass: StripeProduct
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./stripe-product.js").default | null>} */
  ensureStripeProductLoaded() {
    return this.ensureAssociationLoaded("stripe_product")
  }
}
